import { useEffect, useState } from 'react';
import './biz-unsplash-credits.scss';
import { useMediabankGetFrontEndObjectLinks } from '../../Hooks/useMediabank';
import { getPortalSetting } from '../../Services/portal';

interface BizUnsplashCreditsProps {
	imageUrl: string;
}

const BizUnsplashCredits = ({ imageUrl }: BizUnsplashCreditsProps) => {
	const mediabankLinks = useMediabankGetFrontEndObjectLinks('unsplash', getPortalSetting('IsUnsplashEnabled'));
	const [photoCredit, setPhotoCredit] = useState<{ FullName: string; ProfileUrl: string } | null>(null);

	const unsplashUrl = 'https://unsplash.com/?utm_source=bizpart&utm_medium=referral';

	useEffect(() => {
		if (!imageUrl || !imageUrl.toLowerCase().includes('unsplash')) return;

		if (mediabankLinks && mediabankLinks.length > 0) {
			const mbf = mediabankLinks.find((x) => x.MediaBankFile?.FileUrl?.includes(imageUrl))?.MediaBankFile;
			if (mbf) {
				setPhotoCredit({
					FullName: mbf.Settings?.ExternalAuthorName || '',
					ProfileUrl: mbf.Settings?.ExternalAuthorUrl || '',
				});
			}
		}
	}, [imageUrl, mediabankLinks]);

	if (!photoCredit) return null;
	if (!photoCredit.FullName || !photoCredit.ProfileUrl) return null;

	return (
		<span className='unsplash-credits'>
			Photo by{' '}
			<a
				href={`${photoCredit?.ProfileUrl}?utm_source=bizpart&utm_medium=referral`}
				target='_blank'
				rel='noopener noreferrer'
			>
				{photoCredit?.FullName}
			</a>{' '}
			on{' '}
			<a href={unsplashUrl} target='_blank' rel='noopener noreferrer'>
				Unsplash
			</a>
		</span>
	);
};

export default BizUnsplashCredits;
